import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Btn } from "@/components/kit";
import { Subs } from "@/components/Subs";
import logo from "@/assets/logo-white.png";

export default function Welcome() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-surface relative flex items-center justify-center px-6 py-16 overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.14] pointer-events-none"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1609083590460-7b8cc0ca65f8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800)",
          backgroundSize: "cover", backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-surface/50 via-surface/70 to-surface pointer-events-none" />
      <div className="relative max-w-2xl text-center em-fade-up">
        <img src={logo} alt="Primal Integrity" className="w-28 mx-auto opacity-80 mb-10" />
        <div className="overline mb-6">A Twelve-Month Experiment</div>
        <h1 className="font-serif text-5xl sm:text-6xl leading-[1.05] text-ink">
          <Subs>ME₀ → ME₁₁</Subs>
          <span className="block text-gold mt-2">The Emergence Journal</span>
        </h1>
        <p className="mt-8 text-inksoft text-base sm:text-lg leading-relaxed max-w-xl mx-auto">
          You do not need to know where this ends. You only need to know where you are now. Notice,
          choose, move, meet reality — and discover who becomes possible.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <Btn data-testid="begin-journey-btn" onClick={() => navigate("/register")}>Begin your journey</Btn>
          <Btn variant="outline" data-testid="have-account-btn" onClick={() => navigate("/login")}>
            I already have an account
          </Btn>
        </div>
        <p className="mt-14 text-xs text-faint">The Emergence Journal by Sarah Merron · By invitation only</p>
      </div>
    </div>
  );
}
